import { t } from "i18next";
import { Trash } from "iconsax-react";
import { useEffect, useState } from "react";
import DBAutoComplete from "../../component/global/DBAutoComplete";
import DBButton from "../../component/global/DBButton";
import DBFieldBlock from "../../component/global/DBFieldBlock";
import DBSelect from "../../component/global/DBSelect";
import { useRequest } from "../../hooks/helperData/useRequest";
import { SETTING_FEATURES_LIST } from "../../helperData/ApiAddress";
import {
    emptyFeatureRow,
} from "./featureFields";

const languageOptions = () => [
    { value: "fa", label: t("item.type.language.fa") },
    { value: "en", label: t("item.type.language.en") },
    { value: "ar", label: t("item.type.language.ar") },
];

const mandatoryOptions = () => [
    { value: false, label: t("form.feature.mandatory.false") },
    { value: true, label: t("form.feature.mandatory.true") },
];

export default function FeatureFieldsEditor({
    features,
    onChange,
    errors = [],
}) {
    const [options, setOptions] = useState([]);
    const [getFormFeatures] = useRequest(SETTING_FEATURES_LIST, "GET");

    useEffect(() => {
        getFormFeatures({ feature_level: 2 })
            .then((rows) =>
                setOptions(
                    (Array.isArray(rows) ? rows : []).map((item) => ({
                        label: item.name,
                        value: item.name.toLowerCase(),
                        id: item.id,
                        language: item.language,
                    }))
                )
            )
            .catch(() => setOptions([]));
    }, []);

    const updateRow = (index, patch) => {
        const next = [...features];
        next[index] = { ...next[index], ...patch };
        onChange(next);
    };

    return (
        <div className="survey-feature-editor">
            {features.length > 0 && (
                <div className="form-fields-grid survey-feature-grid">
                    {features.map((row, index) => (
                        <div key={`survey-feature-${index}`} className="survey-feature-row">
                            <DBFieldBlock
                                title={t("form.feature.name")}
                                required
                                error={errors[index]}
                            >
                                <DBAutoComplete
                                    status={errors[index] && "error"}
                                    value={
                                        row.feature?.label ||
                                        row.feature?.name ||
                                        ""
                                    }
                                    options={options}
                                    onChange={(caption, option) => {
                                        if (option?.id) {
                                            updateRow(index, {
                                                feature: option,
                                            });
                                            return;
                                        }
                                        updateRow(index, {
                                            feature: {
                                                name: caption,
                                                label: caption,
                                                value: caption,
                                                language:
                                                    row.feature?.language ||
                                                    "fa",
                                                feature_type: 1,
                                                feature_level: 2,
                                            },
                                        });
                                    }}
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("form.feature.language")}
                                required
                            >
                                <DBSelect
                                    disabled={Boolean(row.feature?.id)}
                                    value={row.feature?.language || "fa"}
                                    onChange={(language) =>
                                        updateRow(index, {
                                            feature: {
                                                ...row.feature,
                                                language,
                                            },
                                        })
                                    }
                                    options={languageOptions()}
                                    size="large"
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("form.feature.required")}
                                required
                            >
                                <DBSelect
                                    value={row.mandatory}
                                    onChange={(mandatory) =>
                                        updateRow(index, { mandatory })
                                    }
                                    options={mandatoryOptions()}
                                    size="large"
                                />
                            </DBFieldBlock>
                            <button
                                type="button"
                                className="survey-feature-remove"
                                aria-label={t("survey.features.remove")}
                                title={t("survey.features.remove")}
                                onClick={() =>
                                    onChange(
                                        features.filter((_, i) => i !== index)
                                    )
                                }
                            >
                                <Trash size={20} color="#dc2626" aria-hidden="true" />
                            </button>
                        </div>
                    ))}
                </div>
            )}
            <div className="fullwidth-button">
                <DBButton
                    caption={t("add.form.feature.btn")}
                    className="fullwidth-button"
                    outlined
                    onClick={() => onChange([...features, emptyFeatureRow()])}
                />
            </div>
        </div>
    );
}
